import { useState, useCallback } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

export const useOtpVerification = ({ sendOTPFunc, verifyOTPFunc, onVerified }) => {
  const [loader, setLoader] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [otpBtnDisabled, setOtpBtnDisabled] = useState(true);
  const [otpRequested, setOtpRequested] = useState(false);
  const [showOtpField, setShowOtpField] = useState(false);
  const [countdown, setCountdown] = useState(60);
  const [requestId, setRequestId] = useState('');
  const [phoneError, setphoneError] = useState(false);
  const [otpInvalidFormat, setOtpInvalidFormat] = useState(false);
  const [verified, setVerified] = useState(false);
  const [networkError, setNetworkError] = useState(false);
  const [otpNumericIncorrect, setOtpNumericIncorrect] = useState(false);

  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleCaptcha = useCallback(async () => {
    if (!executeRecaptcha) return null;
    try {
      return await executeRecaptcha();
    } catch (err) {
      console.error('Recaptcha error:', err);
      return null;
    }
  }, [executeRecaptcha]);

  const handlePhoneInput = (value) => {
    const regex = /^[0-9]{10}$/;
    setPhoneNumber(value);
    if (regex.test(value)) {
      setOtpBtnDisabled(false);
      setphoneError(false);
    } else {
      setOtpBtnDisabled(true);
      setphoneError(true);
    }
  };

  const sendOTP = async () => {
    const captchaToken = await handleCaptcha();
    if (!captchaToken) return setNetworkError(true);

    setLoader(true);
    setShowOtpField(true);
    try {
      const response = await sendOTPFunc(phoneNumber, captchaToken);
      const data = await response.json();
      if (response.status === 200) {
        setOtpRequested(true);
        setRequestId(data.result.requestId);
        startCountdown();
      } else {
        throw new Error('Failed to send OTP');
      }
    } catch (err) {
      console.error(err);
      setNetworkError(true);
    } finally {
      setLoader(false);
    }
  };

  const verifyOTP = async (otp) => {
    if (!/^\d{6}$/.test(otp)) {
      setOtpInvalidFormat(true);
      return;
    }

    setOtpInvalidFormat(false);
    setLoader(true);

    const captchaToken = await handleCaptcha();
    if (!captchaToken) {
      setNetworkError(true);
      return;
    }

    try {
      const response = await verifyOTPFunc(requestId, otp, captchaToken);
      if (response.status === 200) {
        setVerified(true);
        setShowOtpField(false);
        setOtpRequested(false)
        setCountdown(0)
        onVerified?.();
      } else {
        setOtpNumericIncorrect(true);
      }
    } catch (err) {
      console.error('OTP verification failed:', err);
      setNetworkError(true);
    } finally {
      setLoader(false);
    }
  };

  const startCountdown = () => {
    setCountdown(30);
    let interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setOtpBtnDisabled(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };
  const verifyPhoneNumberCfForm = () => {
    const enteredOTP = Array.from({ length: 6 }, (_, index) =>
      document.getElementById(`digit${index + 1}`).value
    ).join('');
  
    if (!/^\d{6}$/.test(enteredOTP)) {
      setOtpNumericIncorrect(true);
    } else {
      setOtpNumericIncorrect(false);
      verifyOTP(enteredOTP);
    }
  };  
  
  const handleOtpChange = (e, index) => {
    const input = e.target;
    const value = input.value;
  
    if (/^\d$/.test(value)) {
      input.value = value;
      if (index < 5) {
        const nextInput = document.getElementById(`digit${index + 2}`);
        if (nextInput) nextInput.focus();
      }
      if (index === 5) {
        verifyPhoneNumberCfForm();
      }
    } else {
      input.value = '';
    }
  };
  
  const handleOtpBackspace = (e, index) => {
    if (e.key === 'Backspace' && !e.target.value && index > 0) {
      const prevInput = document.getElementById(`digit${index}`);
      if (prevInput) prevInput.focus();
    }
  };
  
  return {
    loader,
    phoneNumber,
    otpBtnDisabled,
    otpRequested,
    showOtpField,
    countdown,
    phoneError,
    otpInvalidFormat,
    verified,
    networkError,
    otpNumericIncorrect,
    setPhoneNumber,
    setVerified,
    handlePhoneInput,
    sendOTP,
    verifyOTP,
    verifyPhoneNumberCfForm,
    handleOtpChange,
    handleOtpBackspace,
  };
};
